module.exports = __webpack_public_path__ + "img/leadTrash.59e21f49.svg";